import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./UrlInputField.scss";

const UrlInputField = ({
  placeholder = "",
  name = "",
  isRequired,
  label = null,
  isDisabled = false,
  errorMessage = undefined,
  onChange = () => {},
  value = "",
  register = () => {},
  onKeyUp = () => {},
  ...props
}) => {
  return (
    <div className="url-input-field-container">
      {label !== null && (
        <label htmlFor={name}>
          {isRequired && <span className="text-danger">*</span>}
          <span>{label}</span>
        </label>
      )}
      <div
        className={`url-input-field-container__input-section ${
          errorMessage !== undefined && "error-border"
        }`}
      >
        <span>https://</span>
        <input
          type="text"
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={isDisabled}
          {...register(name, { required: isRequired })}
          onChange={onChange}
          onKeyUp={onKeyUp}
          value={value}
          {...props}
        />
      </div>
      <p
        className={`error-message text-danger ${
          errorMessage !== undefined ? "show" : ""
        }`}
      >
        <FontAwesomeIcon
          icon={["fas", "exclamation-circle"]}
          className="mr-2"
          style={{ fontSize: "13px" }}
        />
        {errorMessage !== undefined && <span>{errorMessage.message}</span>}
      </p>
    </div>
  );
};

export default UrlInputField;
